import React, { forwardRef, useState } from "react";
import DatePicker from "react-datepicker";
import {
  IconButton,
  InputAdornment,
  makeStyles,
  TextField,
} from "@material-ui/core";
import CalendarTodayIcon from "@material-ui/icons/CalendarToday";

import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";

interface ICustomDatePickerInput {
  label?: string;
  min?: string;
  max?: string;
  placeholderValue?: string;
  disableValue?: boolean;
  isWeekDays?: boolean;
  value: string;
  setValue: any;
}

const useStyles = makeStyles({
  root: {
    marginTop: "8px",
    paddingBottom: "3px",
    width: "100%",
  },
  override: {
    "& .MuiOutlinedInput-root": {
      height: "50px",
      "& fieldset": {
        borderColor: "#EAEAEA",
      },
      "&:hover fieldset": {
        borderColor: "#EAEAEA",
      },
    },
  },
  picker: {
    "& .react-datepicker-wrapper": {
      width: "100%",
    },
    "& .react-datepicker-popper": {
      zIndex: 10,
    },
  },
});

const CustomDatePickerInput = ({
  label,
  min,
  max,
  disableValue,
  placeholderValue,
  isWeekDays,
  value,
  setValue,
}: ICustomDatePickerInput) => {
  const [date, setDate] = useState("");

  const classes = useStyles();

  const getDateFormatted = (fullDate: Date) => {
    const date = ("0" + fullDate.getDate()).slice(-2);
    const month = ("0" + (fullDate.getMonth() + 1)).slice(-2);
    const year = fullDate.getFullYear();

    return `${year}-${month}-${date}`;
  };

  const isWeekday = (date: Date) => {
    const day = date.getDay();
    return day !== 0 && day !== 6;
  };

  const CustomInput = forwardRef(({ onClick }: any, ref: any) => {
    return (
      <div className={classes.override}>
        <TextField
          className={classes.root}
          variant="outlined"
          label={label}
          defaultValue={
            placeholderValue
              ? placeholderValue
              : value !== ""
              ? moment(value).format("DD/MM/yyyy")
              : ""
          }
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton edge="end">
                  <CalendarTodayIcon />
                </IconButton>
              </InputAdornment>
            ),
          }}
          onClick={onClick}
          ref={ref}
          disabled={disableValue}
        />
      </div>
    );
  });

  return (
    <div className={classes.picker}>
      <DatePicker
        dateFormat="dd/MM/yyyy"
        selected={date}
        minDate={min ? new Date(min) : ""}
        maxDate={max ? new Date(max) : ""}
        showPopperArrow={false}
        onChange={(fullDate: any) => {
          setDate(fullDate);
          setValue(getDateFormatted(fullDate));
        }}
        filterDate={isWeekDays ? isWeekday : ""}
        peekNextMonth
        showMonthDropdown
        showYearDropdown
        dropdownMode="select"
        customInput={<CustomInput />}
        disabled={disableValue}
        todayButton="Today"
      />
    </div>
  );
};

export default CustomDatePickerInput;
